import React from "react";
import { ToastContainer } from "react-toastify";
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import "./App.css";
import logo from "./assets/logo512.png"; // Import your logo
import Strings from "./config/Strings";
const homeDir = Strings.homeDir;

const App = () => {
  const showNavBar = true;

  return (
    <div className="App">
      <nav className="navbar">
        <div style={styles.container}>
          <img src={logo} alt="App Logo" className="navbar-logo navbar-size" />
          <span className="hide-on-mobile" style={styles.description}>
            {" "}
            Track smarter! Live better!
          </span>
        </div>
        {showNavBar && (
          <div className="nav-links">
            <NavLink
              to={homeDir + "/home"}
              className="nav-link"
              activeClassName="active"
            >
              Home
            </NavLink>
            <NavLink
              to={homeDir + "/privacy"}
              className="nav-link"
              activeClassName="active"
            >
              Privacy
            </NavLink>
            <NavLink
              to={homeDir + "/terms"}
              className="nav-link"
              activeClassName="active"
            >
              Terms
            </NavLink>
            <NavLink
              to={homeDir + "/contact"}
              className="nav-link"
              activeClassName="active"
            >
              Contact
            </NavLink>
          </div>
        )}
      </nav>

      <Routes>
        <Route path={homeDir + "/home"} element={<Home />} />
        <Route path={homeDir + "/privacy"} element={<Privacy />} />
        <Route path={homeDir + "/terms"} element={<Terms />} />
        <Route path={homeDir + "/contact"} element={<Contact />} />
        <Route path="*" element={<Navigate to={homeDir + "/home"} />} />
      </Routes>
      <ToastContainer position="top-right" />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    fontSize: "1.5rem",
    position: "absolute",
  },
  label: {
    color: "#fff",
  },
  description: {
    color: "#fff",
  },
};

export default App;
